import { IFeatureFlag } from '../interfaces/IFeatureFlag';

export const featureFlagEnabled = (featureFlags, featureName) => {
    const flagData = featureFlags?.find((flag: IFeatureFlag) => flag.feature === featureName);
    return flagData?.isEnabled;
};
